import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0a0a0a',
          color: '#fff',
          fontFamily: "'Inter', sans-serif",
          padding: 24,
        }}>
          <div style={{
            maxWidth: 400,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 16,
          }}>
            <div style={{ fontSize: '2.5rem' }}>⚓</div>
            <h1 style={{
              fontSize: '1.2rem',
              fontWeight: 700,
              color: 'rgba(255,255,255,0.9)',
              margin: 0,
            }}>
              Algo deu errado
            </h1>
            <p style={{
              fontSize: '0.82rem',
              color: 'rgba(255,255,255,0.5)',
              lineHeight: 1.5,
              margin: 0,
            }}>
              Um erro inesperado aconteceu. Tente recarregar a página.
            </p>
            {this.state.error && (
              <pre style={{
                fontSize: '0.65rem',
                color: 'rgba(255,255,255,0.25)',
                background: 'rgba(255,255,255,0.03)',
                padding: '8px 12px',
                borderRadius: 8,
                maxWidth: '100%',
                overflow: 'auto',
                textAlign: 'left',
                margin: 0,
              }}>
                {this.state.error.message}
              </pre>
            )}
            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button
                onClick={this.handleReload}
                style={{
                  padding: '10px 24px',
                  background: '#D4AF37',
                  color: '#111',
                  border: 'none',
                  borderRadius: 10,
                  fontWeight: 700,
                  fontSize: '0.82rem',
                  cursor: 'pointer',
                }}
              >
                Recarregar
              </button>
              <button
                onClick={this.handleGoHome}
                style={{
                  padding: '10px 24px',
                  background: 'rgba(255,255,255,0.06)',
                  color: 'rgba(255,255,255,0.7)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: 10,
                  fontWeight: 600,
                  fontSize: '0.82rem',
                  cursor: 'pointer',
                }}
              >
                Ir para Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
